module.exports = __webpack_public_path__ + "static/media/video--dark.4362190a.png";